

















import { Component, Prop, Vue } from "vue-property-decorator";
import QUserSelect from "@/common/qUserSelect.vue";
import QCalendar from "@/common/qCalendar.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QPaginate from "@/common/qPaginate.vue";
import contractApi from "@/api/contractApi";
import ContractEdit from "@/components/contract/contractEdit.vue";
import ContractHistory from "@/model/contractHistory";

@Component({
  name: "ContractActiveLog",
  components: {
    QUserSelect,
    QCalendar,
    QTableHeader,
    QPaginate,
    ContractEdit,
  },
})
export default class ContractActiveLog extends Vue {
  @Prop({ required: true })
  contractId;

  public historyList: ContractHistory[] = null;
  mounted() {
    this.getList();
  }

  public async getList() {
    const result = await contractApi.history(this.contractId);

    this.historyList = result;
  }
}
